"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.BackSvg = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, x: "0", y: "0", viewBox: "0 0 32 32" },
        react_1.default.createElement("circle", { fill: "none", cx: "16", cy: "16", r: "16" }),
        react_1.default.createElement("path", { fill: "currentColor", d: "M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-31C7.729 1 1 7.729 1 16s6.729 15 15 15 15-6.729 15-15S24.271 1 16 1z" }),
        react_1.default.createElement("path", { fill: "none", transform: "rotate(-45.001 17.717 16.13)", d: "M12.23 10.46h10.973v11.339H12.23z" }),
        react_1.default.createElement("path", { fill: "currentColor", d: "M24 15H10.828l6.76-6.759-1.415-1.414L7 16l9.432 9.432 1.414-1.414L10.828 17H24z" })));
};
//# sourceMappingURL=BackSvg.js.map